const VISIBLE_PATH_PREFIXES = ['/fa'];

export function isAgentVisibleOnPath(pathname: string): boolean {
  return VISIBLE_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
